var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.$route.name === "sports"
    ? _c(
        "nav",
        { staticClass: "sportmenu-mobile-scrollbar" },
        _vm._l(_vm.navigationItems, function(item, index) {
          return _c(
            "div",
            { key: index, class: ["sport", "section"] },
            [
              item.linktype === "INTERNAL"
                ? _c(
                    "router-link",
                    { attrs: { to: { path: item.area || "/" } } },
                    [
                      item.cssclass && item.cssclass != "default"
                        ? _c("icon", {
                            attrs: {
                              name: item.cssclass,
                              background: "",
                              "color-name": "white",
                              count:
                                item.cssclass === "icon-live"
                                  ? _vm.liveEventsNumber
                                  : 0
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "mobile-menu-text" }, [
                        _vm._v(_vm._s(item.text))
                      ])
                    ],
                    1
                  )
                : item.linktype === "URL"
                ? _c(
                    "router-link",
                    { attrs: { to: { path: item.routing || "/" } } },
                    [
                      item.cssclass && item.cssclass != "default"
                        ? _c("icon", {
                            attrs: {
                              name: item.cssclass,
                              background: "",
                              "color-name": "white"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "mobile-menu-text" }, [
                        _vm._v(_vm._s(item.text))
                      ])
                    ],
                    1
                  )
                : item.linktype === "BONAVIGATION"
                ? _c(
                    "router-link",
                    { attrs: { to: _vm.getBoNavigationPath(item) } },
                    [
                      item.cssclass && item.cssclass != "default"
                        ? _c("icon", {
                            attrs: {
                              name: item.cssclass,
                              background: "",
                              "color-name": "white"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", { staticClass: "mobile-menu-text" }, [
                        _vm._v(_vm._s(item.text))
                      ])
                    ],
                    1
                  )
                : _c("a", { staticClass: "internal", attrs: { href: "#" } }, [
                    _c(
                      "span",
                      { staticClass: "mobile-menu-text" },
                      [
                        item.cssclass && item.cssclass != "default"
                          ? _c("icon", {
                              attrs: {
                                name: item.cssclass,
                                background: "",
                                "color-name": "white"
                              }
                            })
                          : _vm._e(),
                        _vm._v(_vm._s(item.text) + "\n      ")
                      ],
                      1
                    )
                  ])
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-81bc451c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81bc451c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/SportsMenuMobile.vue
// module id = null
// module chunks = 